// ####importing packages####s
import { BrowserRouter, Link, Route, Routes } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Navbar from 'react-bootstrap/NavBar';
import Nav from 'react-bootstrap/Nav';
import Badge from 'react-bootstrap/Badge';
import Container from 'react-bootstrap/Container';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { LinkContainer } from 'react-router-bootstrap';
import { useContext, useEffect, useState } from 'react';
import { Bag } from 'react-bootstrap-icons';
import Button from 'react-bootstrap/Button';
import axios from 'axios';
import { GoogleOAuthProvider } from '@react-oauth/google';
// ####importing context####
import { Store } from './Store';
import { getError } from './utils';
// import SearchBox from './components/SearchBox';
// ####importing components####
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
// ####importing screens####
import HomeScreen from './screens/HomeScreen';
import ProductScreen from './screens/ProductScreen';
import CartScreen from './screens/CartScreen';
import SearchScreen from './screens/SearchScreen';
import SigninScreen from './screens/SignInScreen';
import SignupScreen from './screens/SignupScreen';
import ShippingAddressScreen from './screens/ShippingAddressScreen';
import PaymentMethodScreen from './screens/PaymentMethodScreen';
import PlaceOrderScreen from './screens/PlaceOrderScreen';
import OrderScreen from './screens/OrderScreen';
import OrderHistoryScreen from './screens/OrderHistoryScreen';
import ProfileScreen from './screens/ProfileScreen';
import ContactUsScreen from './screens/ContactUsScreen';
import DashboardScreen from './screens/DashboardScreen';
import ProductListScreen from './screens/ProductListScreen';
import ProductEditScreen from './screens/ProductEditScreen';
import ForgotPasswordScreen from './screens/ForgotPasswordScreen';
import ResetPasswordScreen from './screens/ResetPasswordScreen';
import PromoCodeListScreen from './screens/PromoCodeListScreen';
import AdminOrderListScreen from './screens/AdminOrderListScreen';
import ShippingPriceListScreen from './screens/ShippingPriceListScreen';


function App() {
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { cart, userInfo } = state;

  const signoutHandler = () => {
    ctxDispatch({ type: 'USER_SIGNOUT' });
    localStorage.removeItem('userInfo');
    localStorage.removeItem('shippingAddress');
    localStorage.removeItem('paymentMethod');
    window.location.href = '/signin';
  };

  const [sidebarIsOpen, setSidebarIsOpen] = useState(false);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const { data } = await axios.get(`/api/products/categories`);
        setCategories(data);
      } catch (err) {
        toast.error(getError(err));
      }
    };
    fetchCategories();
  }, []);

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <BrowserRouter>
        <div
          className={
            sidebarIsOpen ? 'active-nav site-container' : 'site-container'
          }
        >
          <ToastContainer position="bottom-center" limit={1} />
          <header>
            <Navbar className="customNavbarStyle" variant="dark" expand="lg">
              <Container>
                <Button
                  variant="#C09695"
                  onClick={() => setSidebarIsOpen(!sidebarIsOpen)}
                >
                  <i className="fas fa-bars" style={{ color: 'white' }}></i>
                </Button>
                <LinkContainer to="/">
                  <Navbar.Brand>
                    <img
                      src="/images/LogoWhite-TransparentBg.png"
                      alt="Q dancewear"
                      className="logo-img"
                    />
                  </Navbar.Brand>
                </LinkContainer>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                  {/* <SearchBox /> */}
                  <Nav className="me-auto w-100 justify-content-end">
                    <Link to="/cart" className="nav-link">
                      <Bag size={30} className="text-white" />
                      {cart.cartItems.length > 0 && (
                        <Badge pill bg="danger">
                          {cart.cartItems.reduce(
                            (previousValue, currentValue) =>
                              previousValue + currentValue.quantity,
                            0
                          )}
                        </Badge>
                      )}
                    </Link>
                    {userInfo ? (
                      <NavDropdown title={userInfo.name} id="basic-nav-dropdown">
                        <LinkContainer to="/profile">
                          <NavDropdown.Item>User Profile</NavDropdown.Item>
                        </LinkContainer>
                        <LinkContainer to="/orderhistory">
                          <NavDropdown.Item>Order History</NavDropdown.Item>
                        </LinkContainer>
                        <NavDropdown.Divider />
                        <Link
                          className="dropdown-item"
                          to="#signout"
                          onClick={signoutHandler}
                        >
                          Sign Out
                        </Link>
                      </NavDropdown>
                    ) : (
                      <Link className="nav-link" to="/signin">
                        Sign In
                      </Link>
                    )}
                    {userInfo?.isAdmin && (
                      <NavDropdown title="Admin" id="admin-nav-dropdown">
                        <LinkContainer to="/admin/dashboard">
                          <NavDropdown.Item>Dashboard</NavDropdown.Item>
                        </LinkContainer>
                        <LinkContainer to="/admin/products">
                          <NavDropdown.Item>Products</NavDropdown.Item>
                        </LinkContainer>
                        <LinkContainer to="/admin/orders">
                          <NavDropdown.Item>Orders</NavDropdown.Item>
                        </LinkContainer>
                        <LinkContainer to="/admin/users">
                          <NavDropdown.Item>Users</NavDropdown.Item>
                        </LinkContainer>
                        <LinkContainer to="/admin/promos">
                          <NavDropdown.Item>Promo Codes</NavDropdown.Item>
                        </LinkContainer>
                        <LinkContainer to="/admin/shipping">
                          <NavDropdown.Item>Shipping Prices</NavDropdown.Item>
                        </LinkContainer>
                      </NavDropdown>
                    )}
                  </Nav>
                </Navbar.Collapse>
              </Container>
            </Navbar>
          </header>
          <div className="side-navbar">
            <Nav className="flex-column text-white w-100 p-2">
              <Nav.Item>
                <strong>Categories</strong>
              </Nav.Item>
              {categories.map((category) => (
                <Nav.Item key={category}>
                  <LinkContainer
                    to={{
                      pathname: '/search',
                      search: `?category=${category}`,
                    }}
                    onClick={() => setSidebarIsOpen(false)}
                  >
                    <Nav.Link className="text-white">{category}</Nav.Link>
                  </LinkContainer>
                </Nav.Item>
              ))}
            </Nav>
            <Nav className="flex-column text-white w-100 p-2">
              <Nav.Item>
                <strong>Help</strong>
                <LinkContainer
                  to="/contactus"
                  onClick={() => setSidebarIsOpen(false)}
                >
                  <Nav.Link className="text-white">Contact Us</Nav.Link>
                </LinkContainer>
              </Nav.Item>
            </Nav>
          </div>
          {sidebarIsOpen && (
            <div className="overlay" onKeyDown={() => setSidebarIsOpen(false)} onClick={() => setSidebarIsOpen(false)}/>
          )}
          <main>
            <Container className="mt-3" fluid={false}>
              <Routes>
                <Route path="/product/:slug" element={<ProductScreen />} />
                <Route path="/cart" element={<CartScreen />} />
                <Route path="/search" element={<SearchScreen />} />
                <Route path="/signin" element={<SigninScreen />} />
                <Route path="/signup" element={<SignupScreen />} />
                <Route
                  path="/profile"
                  element={
                    <ProtectedRoute>
                      <ProfileScreen />
                    </ProtectedRoute>
                  }
                />
                <Route path="/contactus" element={<ContactUsScreen />} />
                <Route path="/placeorder" element={<PlaceOrderScreen />} />
                <Route
                  path="/order/:id"
                  element={
                    <ProtectedRoute>
                      {' '}
                      <OrderScreen />{' '}
                    </ProtectedRoute>
                  }
                ></Route>
                <Route
                  path="/orderhistory"
                  element={
                    <ProtectedRoute>
                      <OrderHistoryScreen />
                    </ProtectedRoute>
                  }
                />
                <Route path="/shipping" element={<ShippingAddressScreen />} />
                <Route path="/payment" element={<PaymentMethodScreen />} />
                {/* Admin Routes */}
                <Route
                  path="/admin/dashboard"
                  element={
                    <AdminRoute>
                      <DashboardScreen />
                    </AdminRoute>
                  }
                ></Route>
                <Route
                  path="/admin/products"
                  element={
                    <AdminRoute>
                      <ProductListScreen />
                    </AdminRoute>
                  }
                ></Route>
                <Route
                  path="/admin/product/:id"
                  element={
                    <AdminRoute>
                      <ProductEditScreen />
                    </AdminRoute>
                  }
                ></Route>
                <Route
                  path="/admin/orders"
                  element={
                    <AdminRoute>
                      <AdminOrderListScreen />
                    </AdminRoute>
                  }
                ></Route>
                <Route
                  path="/admin/promos"
                  element={
                    <AdminRoute>
                      <PromoCodeListScreen />
                    </AdminRoute>
                  }
                ></Route>
                <Route
                  path="/admin/shipping"
                  element={
                    <AdminRoute>
                      <ShippingPriceListScreen />
                    </AdminRoute>
                  }
                ></Route>
                <Route path="/forgot-password" element={<ForgotPasswordScreen />} />
                <Route
                  path="/reset-password/:token"
                  element={<ResetPasswordScreen />}
                />
                <Route path="/" element={<HomeScreen />} />
              </Routes>
            </Container>
          </main>
          <footer>
            <div className="text-center">© 2024 Q dancewear</div>
          </footer>
        </div>
      </BrowserRouter>
    </GoogleOAuthProvider>
  );
  
}
export default App;
